import { render, staticRenderFns } from "./batchAdd.vue?vue&type=template&id=473c8285&scoped=true"
import script from "./batchAdd.vue?vue&type=script&lang=js"
export * from "./batchAdd.vue?vue&type=script&lang=js"
import style0 from "./batchAdd.vue?vue&type=style&index=0&id=473c8285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473c8285",
  null
  
)

export default component.exports